export default {"src":"/_next/static/media/AboutUs_OurJourney.f0150667.svg","height":492,"width":480,"blurWidth":0,"blurHeight":0};